module.exports = __webpack_public_path__ + "static/headshot-steffan-haas.daa3f07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-steffan-haas.jpg
// module id = 539
// module chunks = 152909308826437